// Dependecies
import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import 'antd/dist/antd.css';
// Components
import Popup from 'reactjs-popup';
// Images
import closeIcon from '../../../sass/images/icons/close.svg';

function modalImage({ isBlocked, t, close, urlImage }) {
  const [urlImageTime, setUrlImageTime] = useState(false);
  setTimeout(() => {
    setUrlImageTime(true);
  }, 500);
  return (
    <>
      {urlImageTime ? (
        <Popup open={isBlocked}>
          <div className="modal-design" id="modal-design" />
          <div className="modal-image company">
            <div className="modal-content-image">
              <button type="button" className="close" onClick={close}>
                <img className="modal-img-close" src={closeIcon} alt={t('alt:close')} />
              </button>
              <div className="modal-heading-box">
                <img className="modal-img" src={urlImage} alt={t('alt:successful_process')} />
              </div>
            </div>
          </div>
        </Popup>
      ) : (
        ''
      )}
    </>
  );
}

modalImage.propTypes = {
  isBlocked: PropTypes.bool.isRequired,
  urlImage: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  close: PropTypes.func,
};

export default withTranslation('register')(modalImage);
